import React, { useContext, useEffect } from 'react';
import { Button, ButtonType } from '@riotgames/accounts-react-components';
import AppContext from '../../AppContext';
import cx from 'classnames';
import { GridPanel } from '@riotgames/accounts-react-components/lib/Grid/GridPanel';
import './restrictedGame.scss';

const GAME_NAME = {
  league_of_legends: '리그 오브 레전드',
  bacon: '레전드 오브 룬테라',
  valorant: '발로란트'
};

const RestrictedGames = ({ handleMoveNext }) => {
  const context = useContext(AppContext);
  const {
    state: { age, authToken, restrictedGames },
    actions: { setData, getRestrictedGames }
  } = context;

  useEffect(() => {
    if (restrictedGames.length === 0) {
      moveNext();
    }
  }, []);

  const moveNext = () => {
    handleMoveNext();
  };

  const subTitlePanel = (
    <p className="help-text">회원가입 완료 후 이용 등급에 맞지 않은 아래 게임은 이용하실 수 없습니다.</p>
  );
  const titleOfPanel = '게임 이용 등급 안내';

  return (
    <GridPanel
      title={titleOfPanel}
      subTitle={subTitlePanel}
      button={<Button buttonType={ButtonType.primary} label="가입하기" onClick={moveNext} />}
    >
      <ul className="list-restricted-game">
        {restrictedGames.map((game) => (
          <ItemOfGame key={game.gameId} gameName={GAME_NAME[game.gameId]} restrictedAge={game.minAge} />
        ))}
      </ul>
    </GridPanel>
  );
};

const ItemOfGame = ({ gameName, restrictedAge }) => (
  <li>
    {gameName} ({restrictedAge}세 이용가)
  </li>
);

export default RestrictedGames;
